import { Component, ElementRef, Injector, isDevMode, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';
import { environment } from '../../../environments/environment';
import { } from 'googlemaps';

@Component({
  selector: 'app-googleapi',
  templateUrl: './googleapi.component.html',
  styleUrls: ['./googleapi.component.css']
})
export class GoogleapiComponent extends BaseComponent implements OnInit {
  @ViewChild('map',{static: true}) mapElement: any = {};
  map: any = {};
  showIfDevMode = false;
  env: any = {};
  constructor(injector: Injector) { super(injector) }

  ngOnInit(): void {
    this.env = environment;

    const mapProperties = {
      center: new google.maps.LatLng(35.2271, -80.8431),
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapProperties);
  }
}




